import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { ConfirmationModalComponent } from '../../../shared/confirmation-modal/confirmation-modal.component';
import { ResponseUtil } from '../../../shared/utils/response-util';
import { OnyxEvent } from '../../models/event';
import { EventReservationSource } from '../../models/event-reservation-source';
import { RatePlanCode } from '../../models/rate-plan-code';
import { ReportType } from '../../models/report-type.enum';
import { ReportService } from '../../service/report.service';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { ReservationBulkComponent } from '../reservation-bulk/reservation-bulk.component';
import { ReservationFormComponent } from '../reservation-form/reservation-form.component';

@Component({
  selector: 'pioneer-reservation-button-bar',
  templateUrl: './reservation-button-bar.component.html',
  styleUrls: ['./reservation-button-bar.component.css']
})
export class ReservationButtonBarComponent implements OnInit, OnDestroy {

  private subscription: Subscription = new Subscription();

  @ViewChild(ReservationBulkComponent)
  reservationBulk: ReservationBulkComponent;

  @ViewChild(ReservationFormComponent)
  reservationComponent: ReservationFormComponent;

  @ViewChild(ConfirmationModalComponent)
  noRatePlanCodeModal: ConfirmationModalComponent;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  @Input()
  showDownloadDropdown: boolean;

  onyxEvent: OnyxEvent;

  isAddFormCollapsed: boolean;

  public reservationExcelUrl: string;

  isSummarySelected: boolean;

  @Input()
  summarySelected: boolean;

  summaryReportName: string;

  constructor(
    private reservationCompareStore: ReservationCompareStore,
    private reportService: ReportService,
    public router: Router,
  ) { }

  ngOnInit() {
    if (!this.onyxEvent) {
      throw new Error('The "event" attribute must be specified to use the ReservationButtonBarComponent component');
    }

    this.isAddFormCollapsed = true;

    this.subscription.add(
      this.reservationCompareStore.getShowReservationCompareSummary().subscribe((value: boolean) => {
        this.isSummarySelected = value;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  addReservation(): Observable<any> {
    const obs = this.reservationComponent.addReservation(EventReservationSource.MANUAL)
      .catch((error) => {
        this.isAddFormCollapsed = false;
        return error;
      });

    obs.subscribe(() => {
      this.isAddFormCollapsed = true;
    });

    return obs;
  }

  cancelAddReservation() {
    this.reservationComponent.cancelAddReservation();
    this.isAddFormCollapsed = true;
  }

  disableSave() {
    let disable: boolean;
    if (this.reservationComponent && this.reservationComponent.reservationForm) {
      disable = !this.reservationComponent.reservationForm.valid;
    } else {
      disable = true;
    }
    return disable;
  }

  openUploadBulkReservation() {
    this.reservationBulk.open();
  }

  get canManageReservations(): boolean {
    return this.onyxEvent.canManageReservations;
  }

  getSummaryReport(fileType: string) {
    this.reportService.getReservationsReport(this.onyxEvent.eventId, this.summarySelected, fileType).subscribe(blob => {
      let filename = ResponseUtil.getFileNameFromHttpResponse(blob);
      if (!filename) {
        const reportType = this.summarySelected ? ReportType.RESERVATION_SUMMARY : ReportType.RESERVATION_COMPARE;
        filename = this.reportService.buildReportFileName(reportType, this.onyxEvent, fileType);
      }
      saveAs(blob.body, filename);
    });
  }

  checkRatePlans(event: any) {
    event.preventDefault();
    if (this.onyxEvent.ratePlanCodes && Array.isArray(this.onyxEvent.ratePlanCodes) && this.onyxEvent.ratePlanCodes.length) {
      this.isAddFormCollapsed = !this.isAddFormCollapsed;
    } else {
      this.noRatePlanCodeModal.open();
    }
  }

  noRatePlanCodeModalHandler(addRatePlanCode: boolean) {
    if (addRatePlanCode) {
      this.router.navigate(['event/' + this.onyxEvent.eventId + '/summary/edit']);
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/reservation-button-bar/reservation-button-bar.component.ts